<template>
  <card class="card-stats" :show-footer-line="true" :body-classes="color">

    <div slot="header">
      <b-row>
        <b-col>
          <span class="font-weight-bol mb-0 text-left" v-if="title">{{title}} <span class="text-white" v-if="nonTitle">{{nonTitle}}</span></span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold mb-0 text-right">
            <span v-if="cTitle">
              <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTab(tabId, cTitle)"
                           v-bind:class="btnActivated === cTitle ? 'bg-warning text-white' : ''"
              >{{cTitle}}</base-button>
            </span>
          <span v-if="dTitle">
              <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTab(tabId, dTitle)"
                           v-bind:class="btnActivated === dTitle ? 'bg-warning text-white' : ''"
              >{{dTitle}}</base-button>
            </span>
          <span v-if="mTitle">
              <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTab(tabId, mTitle)"
                           v-bind:class="btnActivated === mTitle ? 'bg-warning text-white' : ''">
                {{mTitle}}</base-button>
            </span>
          <span v-if="yTitle">
              <base-button size="xs" type="secondary" class="p-1 border-radius-none" @click="changeTab(tabId, yTitle)"
                           v-bind:class="btnActivated === yTitle ? 'bg-warning text-white' : ''">
                {{yTitle}}</base-button>
            </span>
          <b-icon
              icon="question-circle"
              variant="orange"
              class="ml-1 mr-1 vertical-align-35"
              v-b-tooltip.hover.top="tooltip">
          </b-icon>
        </b-col>
      </b-row>
    </div>

    <p class="mt-1 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </card>
</template>
<script>
  import Card from '../../../components/Cards/Card.vue';

  export default {
    name: 'statistics',
    components: {
      Card
    },
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      tabId: String,
      icon: String,
      title: String,
      nonTitle: String,
      cTitle: String,
      dTitle: String,
      mTitle: String,
      yTitle: String,
      iconClasses: [String, Array],
      color: String,
      tooltip: String,
    },
    data() {
      return {
        btnActivated: 'Current'
      }
    },
    methods: {
      changeTab(id, title) {
        switch (id) {
          case 'dataSession': {
            this.$emit('changeSessionTab', title);
            this.btnActivated = title;
            break;
          }
          case 'dataVolume': {
            this.$emit('changeVolumeTab', title);
            this.btnActivated = title;
            break;
          }
          case 'alerts': {
            this.$emit('changeAlertsTab', title);
            this.btnActivated = title;
            break;
          }
          case 'zeroSessions': {
            this.$emit('changeZeroSessionsTab', title);
            this.btnActivated = title;
            break;
          }
          default:
            break;
        }

      }
    }
  };
</script>
